import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import SEO, { orgJsonLd, breadcrumbJsonLd } from "../components/SEO";
import Reveal from "../components/Reveal";
import { BLOG_POSTS } from "../data/siteData";

export default function BlogPage() {
  return (
    <>
      <SEO
        title="Resources & Blog — Startup Compliance, Valuation & Fundraising Guides | Complisure"
        description="Practical guides on company registration, ROC compliance, GST, Virtual CFO, business valuation and fundraising — written by practising CAs, CSs and lawyers."
        canonical="https://compliance-capital-1.preview.emergentagent.com/blog"
        jsonLd={[orgJsonLd, breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Blog", path: "/blog" }])]}
      />
      <section className="relative overflow-hidden pb-20 pt-36">
        <div className="blob blob-float right-[-8%] top-[-8%] h-96 w-96 bg-brand-blue/10" />
        <div className="dot-grid absolute inset-0 opacity-[0.1]" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
          <Reveal>
            <h1 className="max-w-3xl font-display text-4xl font-extrabold tracking-[-0.02em] text-brand-navy sm:text-5xl">
              Playbooks from the <span className="text-gradient">compliance trenches</span>
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-brand-gray sm:text-lg">
              No fluff, no regurgitated circulars. What 800+ engagements taught us about registration, tax, valuation and fundraising in India.
            </p>
          </Reveal>

          <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {BLOG_POSTS.map((p, i) => (
              <Reveal key={p.slug} delay={(i % 3) * 0.08}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="glass card-lift group flex h-full flex-col rounded-3xl p-7">
                  <div className="flex items-center justify-between">
                    <span className="rounded-full bg-brand-ice px-3 py-1 text-xs font-semibold text-brand-blue">{p.category}</span>
                    <span className="flex items-center gap-1 text-xs text-brand-gray"><Clock className="h-3 w-3" /> {p.readTime}</span>
                  </div>
                  <h2 className="mt-4 font-display text-lg font-bold leading-snug tracking-tight text-brand-navy group-hover:text-brand-blue">{p.title}</h2>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-brand-gray">{p.excerpt}</p>
                  <div className="mt-4 flex items-center justify-between border-t border-brand-blue/10 pt-4">
                    <span className="text-xs text-brand-gray">{new Date(p.date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</span>
                    <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue transition-all group-hover:gap-3">Read <ArrowRight className="h-4 w-4" /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
